<div  class="image-wrapper text-skeleton skeleton">

</div>
<div 
  class="image-wrapper text-skeleton secondSkeleton ">

</div>